import '@/styles/globals.css'

import '@fontsource/ibm-plex-sans/300.css'
import '@fontsource/ibm-plex-sans/400.css'
import '@fontsource/ibm-plex-sans/500.css'
import '@fontsource/ibm-plex-sans/600.css'
import '@fontsource/ibm-plex-sans/700.css'

import type { FC, ReactNode } from 'react'
import type { AppProps } from 'next/app'

import { MotionProvider } from '@/components/generals/motion-provider'

const App: FC<AppProps> = ({ Component, pageProps }): ReactNode => {
    return (
        <MotionProvider>
            <Component {...pageProps} />
        </MotionProvider>
    )
}

export default App
